.page {
  composes: pageShell from "../../shared/styles/layout.module.css";
}

.header {
  composes: pageHeader from "../../shared/styles/layout.module.css";
}

.headerToggle {
  composes: headerToggle from "../../shared/styles/layout.module.css";
}

.headerContent {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-column: wide;
  justify-content: space-between;
  gap: var(--p-spacing-sm);
  padding-block: var(--p-spacing-md);
}

.title {
  margin: 0;
}

.content {
  grid-column: wide;
  padding-block: var(--p-spacing-md);
}
